<form [formGroup]="externalCustomerSearchForm">
  <div class="searchBox input-container">
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
      <path
        d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"
      />
    </svg>
    <input
      #searchBox
      [ngClass]="{ expanded: show }"
      [autofocus]="!disabled"
      type="text"
      [placeholder]="placeHolder"
      formControlName="externalCustomerSearch"
      class="form-control"
      (focus)="isFocus($event)"
      (blur)="lostFocus($event)"
      (keyup)="onKeyboard($event)"
    />
    <span class="loading-spinner" *ngIf="loading$ | async">
      <pos-app-spinner2 [dark]="true"></pos-app-spinner2>
    </span>
  </div>
  <div>
    <div #searchResult *ngIf="show" [ngClass]="forOrderHeader ? 'forOrderHeaderResult' : 'searchResult'">
      <div style="max-height: 300px; overflow-y: auto">
        <table *ngIf="listOfCustomers.length > 0" class="border my-4 table table-striped shadow-lg w-100">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase">
                <label>Customer Name</label>
              </th>
              <th scope="col" class="text-uppercase">
                <label>EMAIL</label>
              </th>
              <th scope="col" class="text-uppercase text-nowrap">
                <label>FULL NAME</label>
              </th>
              <th scope="col" class="text-uppercase text-nowrap">
                <label>Customer Number</label>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              (click)="selectCustomer(customer)"
              *ngFor="let customer of externalCustomer$ | async; let i = index"
              [ngClass]="i === indexFocus ? 'table-primary' : ''"
            >
              <td>
                <ngb-highlight [result]="customer.customerName" [term]="externalCustomerSearchForm.get('externalCustomerSearch').value">
                </ngb-highlight>
              </td>
              <td>
                <ngb-highlight [result]="customer.email" [term]="externalCustomerSearchForm.get('externalCustomerSearch').value"></ngb-highlight>
              </td>
              <td>
                <ngb-highlight [result]="customer.fullName" [term]="externalCustomerSearchForm.get('externalCustomerSearch').value"></ngb-highlight>
              </td>
              <td>
                <ngb-highlight
                  [result]="customer?.parentCustomerNumber"
                  [term]="externalCustomerSearchForm.get('externalCustomerSearch').value"
                ></ngb-highlight>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</form>
